export const DashboardNutritionUpgrade = {
  bindings: {
    recipeCollection: '<',
  },

  template: `
    <div class="dashboard-nutrition-upgrade">
      <section class="dashboard-cards">
        <div class="container">
          <div class="row">
            <div class="card-wrapper card-sm col pointer active">
              <card-image
                card-class="text-center bg-teal-dark"
                img="$ctrl.recipeCollection.coverImageUrl.magazine">
                <small class="tagline">
                  This week on <span class="text-orange">Voome Nutrition</span>
                </small>
                <h4 class="card-title">
                  {{ $ctrl.recipeCollection.title }}
                </h4>
              </card-image>
              <box-arrow-row color="white"></box-arrow-row>
              <div class="d-md-none" ng-switch-when="3">
                <dashboard-nutrition-hack
                  title="$ctrl.recipeCollection.title"
                  description="$ctrl.recipeCollection.strapLine"
                  items="$ctrl.recipeCollection.recipes">
                </dashboard-nutrition-hack>
              </div>
            </div>
          </div>
        </div>
      </section>
      <dashboard-nutrition-hack
        title="$ctrl.recipeCollection.title"
        description="$ctrl.recipeCollection.strapLine"
        items="$ctrl.recipeCollection.recipes">
      </dashboard-nutrition-hack>
      <div class="container">
        <div class="row">
          <div class="card-wrapper col pointer active">
            <a class="d-block text-center p-4 mt-3 mb-sm-0 btn-unstyled bg-teal-dark"
              ng-click="$ctrl.onClick()">
              <h5 class="text-white">Recipes at your fingertips</h5>
              <p class="text-white">
                Get full access to 20,000 recipes and over 30 recipes collections for only $3/week.
              </p>
              <button class="btn btn-pill theme-btn btn-md"
                type="button"
                ng-click="$ctrl.onClick()">
                Learn More
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>`,

  controller($state) {
    'ngInject';

    return {
      onClick() {
        $state.go('nutrition');
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/NutritionUpgrade.js